module.exports = __webpack_public_path__ + "img/D201812_1.2f82d8ec.jpg";